import { MasterConfigContext } from "@/context/MasterConfigContext";
import { getDataFromSSR } from "@/handlers/client/commonClient";
import {
  apstagBidCallback,
  createApsSlotsRosDesktop,
  createApsSlotsRosMobile,
  requestBiddingFromPWT,
} from "@/utils/ads";
import dynamic from "next/dynamic";

const NikayPageWidget = dynamic(() =>
  import("@/component/NikayChunav/NikayPageWidget")
);
const ResultWidget = dynamic(() =>
  import("@/component/NikayChunav/ResultWidget")
);
const AdSlot300x250 = dynamic(() => import("@/component/Ads/AdSlot300x250"));
const AdSlot728x90 = dynamic(() => import("@/component/Ads/AdSlot728x90"));
const HeadTag = dynamic(() => import("@/component/SeoTags/HeadTag"));
const GTMScript = dynamic(() => import("@/component/Ads/GTMScript"));
const Breadcrumb = dynamic(() => import("@/component/Breadcrumb"));
const BreadcrumbSchema = dynamic(() =>
  import("@/component/SeoTags/BreadcrumbSchema")
);
const ItemsList = dynamic(() => import("@/component/SeoTags/ItemsList"));
const WebpageSchema = dynamic(() =>
  import("@/component/SeoTags/WebpageSchema")
);

 
import { useRouter } from "next/router";
import { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { useInView } from "react-intersection-observer";
import Select from "react-select";
const List1 = dynamic(() => import("@/component/Listing/List1"));
const List2 = dynamic(() => import("@/component/Listing/List2"));

const NikayChunav = ({
  resultData = [],
  isMobileDevice = false,
  activeTab = -1,
  topicNewsListData = null,
  categoryNewsList = null,
}) => {
  const router = useRouter();
  const [currentConst, setCurrentConst] = useState("सभी");
  const [latestResultData, setLatestResultData] = useState(resultData);
  const [currentPage, setCurrentPage] = useState(1);
  const [firstScroll, setFirstScroll] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [loadingSpinner, setLoadingSpinner] = useState(false);
  const masterConfig = useContext(MasterConfigContext);
  const hrElectionKeys = masterConfig["haryana_election"];

  const currentTab = activeTab;
  const [y, setY] = useState(
    typeof window !== "undefined" && document.scrollingElement.scrollHeight
  );
  const [scrollDirection, setScrollDirection] = useState(
    "you have not scrolled yet"
  );
  const [categoryData, setCategoryData] = useState(categoryNewsList?.content);
  //category data effects
  useEffect(() => {
    if (currentTab != -1) return;
    setCategoryData(categoryNewsList?.content);
  }, [categoryNewsList?.content]);

  useEffect(() => {
    if (currentTab != -1) return;
    const handleRouteChangeComplete = (url) => {
      setCurrentPage(1);
    };

    router.events.on("routeChangeComplete", handleRouteChangeComplete);

    return () => {
      router.events.off("routeChangeComplete", handleRouteChangeComplete);
    };
  }, [router.events]);

  const [insightref, insightView] = useInView({
    threshold: 0,
    rootMargin: "40%",
  });
  const [mobileInsightref, mobInsightView] = useInView({
    threshold: 0,
    rootMargin: "40%",
  });

  const resultObj = latestResultData[0];
  const resultTabData =
    currentTab == 1
      ? resultObj?.mayorData
      : currentTab == 2
      ? resultObj?.nagarData
      : resultObj?.parshadData;

  useEffect(() => {
    try {
      const interval = setInterval(async () => {
        const resultReponse = await fetch(
          "https://elections.mobiletak.com/jsonfiles/exitpolls/HRNikayData.json" +
            "?time=" +
            Date.now(),{
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
        );
        const resultData = await resultReponse?.json();
        setLatestResultData(resultData);
      }, 10000);

      return () => clearInterval(interval);
    } catch (err) {
      console.log(err);
    }
  }, []);

  const constList = useMemo(() => {
    if (activeTab == 2) {
      if (!resultObj?.adhyakshConstit) return [];

      return [
        { label: "सभी", engName: "सभी", value: 0 },
        ...resultObj.adhyakshConstit.map((item, index) => ({
          label: item,
          engName: item,
          value: index + 1,
        })),
      ];
    } else if (activeTab != -1) {
      if (!resultObj?.constituencies) return [];

      return [
        { label: "सभी", engName: "सभी", value: 0 },
        ...resultObj.constituencies
        .filter((item) => activeTab !== 3 || (item !== "अंबाला" && item !== "सोनीपत"))
        .map((item, index) => ({
          label: item,
          engName: item,
          value: index + 1,
        })),
      ];
    }
  }, [resultObj?.constituencies]);

  //ads
  useEffect(() => {
    setTimeout(() => {
      window.googletag = window.googletag || { cmd: [] };

      if (window.screen.width < 900) {
        googletag.cmd.push(function () {
          googletag.destroySlots();
          googletag
            .defineSlot(
              "/1007232/News_tak_Mobile_ROS_ATF_300x250",
              [300, 250],
              "div-gpt-ad-1659434453897-0"
            )
            .addService(googletag.pubads());
          currentTab == -1 &&
            topicNewsListData &&
            topicNewsListData?.content.length > 0 &&
            googletag
              .defineSlot(
                "/1007232/News_tak_Mobile_ROS_MTF_1_300x250",
                [300, 250],
                "div-gpt-ad-1659434604998-0"
              )
              .addService(googletag.pubads());
          googletag
            .defineSlot(
              "/1007232/News_tak_Mobile_ROS_BTF_300x250",
              [300, 250],
              "div-gpt-ad-1659435474737-0"
            )
            .addService(googletag.pubads());
          googletag
            .defineSlot(
              "/1007232/News_tak_Mobile_ROS_Bottom_320x50",
              [320, 50],
              "div-gpt-ad-1659435612077-0"
            )
            .addService(googletag.pubads());

          // googletag.pubads().enableSingleRequest();
          googletag.pubads().disableInitialLoad();
          googletag.enableServices();
          requestBiddingFromPWT();
          // Object.keys(keyBindings).forEach((key) => {
          //   googletag.pubads().setTargeting(key, keyBindings[key]);
          // });
          googletag.cmd.push(function () {
            var INTERSTITIALAd = googletag
              .defineOutOfPageSlot(
                "/1007232/News_tak_Mobile_ROS_Mweb_Interstitial",
                googletag.enums.OutOfPageFormat.INTERSTITIAL
              )
              .addService(googletag.pubads());

            googletag.display(INTERSTITIALAd);
          });
        });
      } else {
        googletag.cmd.push(function () {
          googletag.destroySlots();
          googletag
            .defineSlot(
              "/1007232/News_tak_Desktop_ROS_ATF_728x90",
              [728, 90],
              "div-gpt-ad-1659424515060-0"
            )
            .addService(googletag.pubads());
          googletag
            .defineSlot(
              "/1007232/News_tak_Desktop_ROS_ATF_300x250",
              [300, 250],
              "div-gpt-ad-1707804176041-1"
            )
            .addService(googletag.pubads());

          currentTab == -1 &&
            topicNewsListData &&
            topicNewsListData?.content.length > 0 &&
            googletag
              .defineSlot(
                "/1007232/News_tak_Desktop_ROS_MTF_1_728x90",
                [728, 90],
                "div-gpt-ad-1707804176041-2"
              )
              .addService(googletag.pubads());
          googletag
            .defineSlot(
              "/1007232/News_tak_Desktop_ROS_BTF_728x90",
              [728, 90],
              "div-gpt-ad-1659425743360-0"
            )
            .addService(googletag.pubads());

          // googletag.pubads().enableSingleRequest();
          googletag.pubads().disableInitialLoad();
          googletag.enableServices();
          requestBiddingFromPWT();
          // Object.keys(keyBindings).forEach((key) => {
          //   googletag.pubads().setTargeting(key, keyBindings[key]);
          // });
        });
      }
      apstag?.fetchBids(
        {
          slots:
            window.screen.width < 900
              ? createApsSlotsRosMobile({ mtf2: false, mtf3: false })
              : createApsSlotsRosDesktop({ mtf2: false, mtf3: false }),
          timeout: 2e3,
        },
        apstagBidCallback
      );
    }, 10);
  }, []);

  const customFilterOption = (option, searchText) => {
    if (
      option.data.label.toLowerCase().includes(searchText.toLowerCase()) ||
      option.data.engName.toLowerCase().includes(searchText.toLowerCase())
    ) {
      return true;
    }
    return false;
  };

  // -- infinite scroll //
  const getMorePost = async () => {
    const websiteUrl = process.env.NEXT_PUBLIC_WEBSITE_URL;
    setLoadingSpinner(true);
    let fetchedData = await getDataFromSSR(
      `${websiteUrl}/api/getCategoryPosts?page=${currentPage}&category=/haryana`
    );

    if (fetchedData?.data?.categoryNewsListData?.content?.length > 0) {
      setCategoryData([
        ...categoryData,
        ...fetchedData?.data?.categoryNewsListData?.content,
      ]);
    } else {
      setHasMore(false);
    }
    setLoadingSpinner(false);
  };
  const handleNavigation = useCallback(
    (e) => {
      if (y > window.scrollY) {
        setScrollDirection("Scrolling Up");
      } else if (y < window.scrollY) {
        setScrollDirection("Scrolling Down");
      }

      setY(window.scrollY);
    },
    [y]
  );
  useEffect(() => {
    if (currentTab != -1) return;
    window.addEventListener("scroll", handleNavigation);

    return () => {
      window.removeEventListener("scroll", handleNavigation);
    };
  }, [handleNavigation]);

  useEffect(() => {
    if (currentTab != -1) return;
    if (
      (insightView || mobInsightView) &&
      scrollDirection == "Scrolling Down" &&
      hasMore
    ) {
      if (!firstScroll) {
        setFirstScroll(true);
      }
      setCurrentPage(currentPage + 1);
    }
  }, [insightView, mobInsightView, scrollDirection]);

  useEffect(() => {
    if (currentTab != -1) return;
    currentPage >= 1 && getMorePost();
    let height = window?.scrollY;
    window.scrollTo(0, height);
  }, [currentPage]);

  // -- infinite scroll //
  let title = "Haryana Nikay Chunav";
  let description = "News Tak: Haryana Nikay Chunav page";
  let keywords = "Haryana, Nagar Nikay Chunav, Haryana Chunav";

  switch (currentTab) {
    case -1:
      title =
        "Haryana Nikay Chunav 2025: Live Updates, Results, and Latest News";
      description =
        "Get real-time updates on Haryana Nikay Chunav 2025, including election results, mayoral contests, ward-wise results, and key highlights. Track candidate lists and victory margins.";
      keywords =
        "Haryana Nikay Chunav, Haryana Municipal Election 2025, Haryana Election Results, Mayor Election Haryana, Parshad Chunav Haryana, Haryana Adhyaksh Election";
      break;
    case 1:
      title =
        "Haryana Mayor Election 2025: Results, Candidates, and Latest News";
      description =
        "Haryana Mayor Election 2025 Result: Catch all the latest updates on Haryana Mayor Election 2025, including candidate lists, results, winning mayors, and detailed analysis. Stay informed with live coverage.";
      keywords =
        "Haryana Mayor Election 2025, Haryana Mayor Chunav, Mayor Election Results, Haryana Municipal Mayor Results, Mayor Candidate List Haryana";
      break;
    case 2:
      title = "Haryana Adhyaksh Election 2025: Live Results and Updates";
      description =
        "Haryana Adhyaksh Election 2025 Result: Stay updated with Haryana Adhyaksh Election 2025 live results, key announcements, winning candidates, and comprehensive coverage. Know who takes the Adhyaksh seat.";
      keywords =
        "Haryana Adhyaksh Election 2025, Adhyaksh Chunav Haryana, Haryana Municipal Adhyaksh, Adhyaksh Election Results, Haryana Adhyaksh Candidate List";
      break;
    case 3:
      title =
        "Haryana Parshad Election 2025: Ward-Wise Results and Candidate Updates";
      description =
        "Haryana Parshad Election 2025 Result: Find here Haryana Parshad Election 2025 with real-time updates, ward-wise results, candidate details, and latest news. Stay ahead with accurate election insights.";
      keywords =
        "Haryana Parshad Election 2025, Parshad Chunav Haryana, Ward Wise Results Haryana, Municipal Parshad Results, Haryana Parshad Election Candidates";
      break;
    default:
      title =
        "Haryana Nikay Chunav 2025: Live Updates, Results, and Latest News";
      description =
        "Get real-time updates on Haryana Nikay Chunav 2025, including election results, mayoral contests, ward-wise results, and key highlights. Track candidate lists and victory margins.";
      keywords =
        "Haryana Nikay Chunav, Haryana Municipal Election 2025, Haryana Election Results, Mayor Election Haryana, Parshad Chunav Haryana, Haryana Adhyaksh Election";
      break;
  }
  let canonical = "/haryana-nikay-chunav";
  if (currentTab == 1) {
    canonical = "/haryana-nikay-chunav/mayor";
  }
  if (currentTab == 2) {
    canonical = "/haryana-nikay-chunav/adhyaksh";
  }
  if (currentTab == 3) {
    canonical = "/haryana-nikay-chunav/parshad";
  }

  let heading = "हरियाणा नगर निकाय चुनाव परिणाम 2025";

  if (currentTab == 1) {
    heading = "हरियाणा नगर निकाय मेयर चुनाव परिणाम 2025";
  }
  if (currentTab == 2) {
    heading = "हरियाणा नगर निकाय अध्यक्ष चुनाव परिणाम 2025";
  }
  if (currentTab == 3) {
    heading = "हरियाणा नगर निकाय पार्षद चुनाव परिणाम 2025";
  }

  const breadCrumbs = [
    {
      id: "1",
      title: "हरियाणा निकाय चुनाव",
      canonical_url: "/haryana-nikay-chunav",
      amp_url: "",
    },
    ...(currentTab == 1
      ? [
          {
            id: "2",
            title: "मेयर",
            canonical_url: "/haryana-nikay-chunav/mayor",
            amp_url: "",
          },
        ]
      : []),
    ...(currentTab == 2
      ? [
          {
            id: "3",
            title: "अध्यक्ष",
            canonical_url: "/haryana-nikay-chunav/adhyaksh",
            amp_url: "",
          },
        ]
      : []),
    ...(currentTab == 3
      ? [
          {
            id: "4",
            title: "पार्षद",
            canonical_url: "/haryana-nikay-chunav/parshad",
            amp_url: "",
          },
        ]
      : []),
  ];

  return (
    <section>
      {/* Schemas+SEO */}
      <HeadTag
        title={title}
        description={description}
        keywords={keywords}
        canonicalUrl={process.env.NEXT_PUBLIC_WEBSITE_URL + canonical}
        noAuthorTag={false}
        image={topicNewsListData?.seo_detail?.og_image}
        lcpImage={`${topicNewsListData?.content?.[0]?.image_small}?size=360:203`}
      />
      <GTMScript isElection={true} />
      <WebpageSchema
        title={title}
        description={description}
        keywords={keywords}
        canonicalUrl={process.env.NEXT_PUBLIC_WEBSITE_URL + canonical}
      />
      <BreadcrumbSchema breadcrumbList={breadCrumbs} />

      <ItemsList
        data={
          categoryNewsList?.length > 0
            ? [...categoryNewsList?.content, ...topicNewsListData?.content]
            : topicNewsListData?.content
        }
      />
      <Breadcrumb breadcrumbList={breadCrumbs} isHR={true} />

      <div className="mx-auto px-4">
        <AdSlot728x90
          divId="div-gpt-ad-1659424515060-0"
          minWidth="720px"
          minHeight="90px"
        />
      </div>
      <h1 className="text-hrDark text-2xl font-bold px-2 my-4">{heading}</h1>
      {hrElectionKeys?.showNikayWidgetPage && (
        <ResultWidget
          latestResultData={resultObj?.totalResult}
          isMobileDevice={isMobileDevice}
          isSSR={true}
        />
      )}

      <div className="flex flex-col md:flex-row items-center justify-between">
        {/* tabs */}
        <div className="w-full md:w-[65%] flex justify-start items-center my-4 md:my-2  gap-2 px-2">
          {hrElectionKeys?.showNikayTables && (
            <span
              onClick={() => {
                window.open("/haryana-nikay-chunav", "_self");
              }}
              className={`rounded-lg p-1 cursor-pointer ${
                currentTab === -1 ? "bg-[#64BC46] text-white" : ""
              } w-[25%] md:w-[20%] border border-gray-400 text-md md:text-xl text-center`}
              role="button"
            >
              खबरें
            </span>
          )}
          {hrElectionKeys?.showNikayTables && (
            <span
              onClick={() => {
                window.open("/haryana-nikay-chunav/mayor", "_self");
              }}
              className={`rounded-lg p-1 cursor-pointer ${
                currentTab === 1 ? "bg-[#64BC46] text-white" : ""
              } w-[25%] md:w-[20%] border border-gray-400 text-md md:text-xl text-center`}
              role="button"
            >
              मेयर
            </span>
          )}
          {hrElectionKeys?.showNikayTables && (
            <span
              onClick={() => {
                window.open("/haryana-nikay-chunav/adhyaksh", "_self");
              }}
              className={`rounded-lg p-1 cursor-pointer ${
                currentTab === 2 ? "bg-[#64BC46] text-white" : ""
              } w-[25%] md:w-[20%] border border-gray-400 text-md md:text-xl text-center`}
              role="button"
            >
              अध्यक्ष
            </span>
          )}
          {hrElectionKeys?.showNikayTables && (
            <span
              onClick={() => {
                window.open("/haryana-nikay-chunav/parshad", "_self");
              }}
              className={`rounded-lg p-1 cursor-pointer ${
                currentTab === 3 ? "bg-[#64BC46] text-white" : ""
              } w-[25%] md:w-[20%] border border-gray-400 text-md md:text-xl text-center`}
              role="button"
            >
              पार्षद
            </span>
          )}
        </div>
        {/* city selection */}
        {currentTab != -1 && hrElectionKeys?.showNikayTables && (
          <div className="w-full md:w-[35%] px-4 py-2">
            <span className="bg-white relative text-sm ms-2 -top-3.5 z-10">
              नगर निगम का नाम
            </span>
            <Select
              onChange={(e) => {
                setCurrentConst(e);
              }}
              options={constList}
              value={currentConst}
              placeholder="सभी"
              isSearchable={true}
              filterOption={customFilterOption}
              className="relative w-full text-md -mt-6"
            />
          </div>
        )}
      </div>
      <div className="mx-4 px-4">
        <AdSlot300x250
          divId="div-gpt-ad-1659434453897-0"
          minWidth="300px"
          minHeight="250px"
        />
      </div>
      {currentTab != -1 && (
        <NikayPageWidget
          tab={currentTab}
          resultData={resultTabData}
          currentConst={currentConst}
          totalData={resultObj?.totalResult[0]}
          hrElectionKeys={hrElectionKeys}
        />
      )}
      <div className="mx-4 my-4">
        {isMobileDevice &&
          topicNewsListData &&
          topicNewsListData?.content.length > 0 && (
            <List1
              title={"चुनाव की खबरें"}
              newsListData={topicNewsListData?.content}
              isLCP={true}
              haveH1={false}
              showAds={false}
              election={false}
            />
          )}
        {!isMobileDevice &&
          topicNewsListData &&
          topicNewsListData?.content.length > 0 && (
            <List2
              title={"चुनाव की खबरें"}
              newsListData={topicNewsListData?.content}
              isLCP={true}
              haveH1={false}
              showAds={false}
              election={false}
            />
          )}

        {currentTab == -1 &&
          topicNewsListData &&
          topicNewsListData?.content.length > 0 && (
            <AdSlot300x250
              divId="div-gpt-ad-1659434604998-0"
              minWidth="300px"
              minHeight="250px"
            />
          )}
        {currentTab == -1 &&
          topicNewsListData &&
          topicNewsListData?.content.length > 0 && (
            <AdSlot728x90
              divId="div-gpt-ad-1707804176041-2"
              minWidth="720px"
              minHeight="90px"
            />
          )}
        {isMobileDevice &&
          categoryNewsList &&
          categoryNewsList?.content.length > 0 &&
          currentTab == -1 && (
            <>
              <List1
                title={"हरियाणा की खबरें"}
                newsListData={
                  firstScroll ? categoryData : categoryNewsList?.content
                }
                isLCP={true}
                haveH1={false}
                showAds={false}
                election={false}
              />
              <div
                className="text-sports news-load h-[50px] w-full mb-4"
                ref={mobileInsightref}
              >
                {loadingSpinner === true && (
                  <div className="flex items-center justify-center">
                    <div className="animate-spin rounded-full border-t-4 border-hrDark border-solid h-12 w-12"></div>
                  </div>
                )}
              </div>
            </>
          )}
        {!isMobileDevice &&
          categoryNewsList &&
          categoryNewsList?.content.length > 0 && (
            <>
              <List2
                title={"हरियाणा की खबरें"}
                newsListData={
                  firstScroll ? categoryData : categoryNewsList?.content
                }
                isLCP={true}
                haveH1={false}
                showAds={false}
                election={false}
              />
              <div
                className="text-sports news-load h-[50px] w-full mb-4"
                ref={insightref}
              >
                {loadingSpinner === true && (
                  <div className="flex items-center justify-center">
                    <div className="animate-spin rounded-full border-t-4 border-hrDark border-solid h-12 w-12"></div>
                  </div>
                )}
              </div>
            </>
          )}
        <AdSlot300x250
          divId="div-gpt-ad-1659435474737-0"
          minWidth="300px"
          minHeight="250px"
        />
        <AdSlot728x90
          divId="div-gpt-ad-1659425743360-0"
          minWidth="720px"
          minHeight="90px"
        />
      </div>
    </section>
  );
};

export default NikayChunav;
